import { Component, HostListener } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { EmdmIcons } from 'src/app/services/appicons.service';
import { commonService } from 'src/app/services/common.service';
import { CalService } from '../../../auth/cal.service';
import { EMDMICONS } from '../constants/icon-pack.constant';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  welcomeName: string | undefined;
  resultName: string = "";
  Name: string = "";
  faLogout = this.iconPack.FaRightCheck;
  setLoginDisplay !: boolean | null;
  testdisplay: string | undefined;
  userRole: string | undefined;
  isSpecialist: boolean = false;
  activeMenu = "dashboard";
  userIsActive = true;

  constructor(private router: Router, private calService: CalService, private commonservice: commonService, private iconPack: EmdmIcons) {
  }

  ngOnInit() {
    this.calService.userSubject.subscribe((x: any) => {
      this.welcomeName = sessionStorage.getItem('fullName') ?? '';
    });

    this.commonservice.isSpecialist.subscribe((isSpecialist: boolean) => {
      this.userIsActive = (sessionStorage.getItem("userIsActive") ?? '') == "true";
      this.isSpecialist = isSpecialist;
    });

    this.commonservice.userIsActive.subscribe((status: any) => {
      if (status != null) {
        this.userIsActive = status;
      }
    });

    let splittedUrl = window.location.href.split('/');
    let url = splittedUrl[splittedUrl.length - 1];
    if (url !== '') {
      this.activeMenu = splittedUrl.includes('ACD') ? 'Dashboard' : url;
    }

    this.router.events.subscribe((event) => {
      if ((event instanceof NavigationEnd)) {
        if (event.url?.toLocaleLowerCase() == '/' || (event.url?.toLocaleLowerCase().includes('dashboard') && !event.url?.toLocaleLowerCase().includes('reporting-dashboard'))) {
          this.activeMenu = "dashboard";
        }
        else if (event.url?.toLocaleLowerCase().includes('dataconsole')) {
          this.activeMenu = "dataconsole";
        }
        else if (event.url?.toLocaleLowerCase().includes('reporting-dashboard')) {
          this.activeMenu = "reporting-dashboard";
        }
        else if (event.url?.toLocaleLowerCase().includes('user-manager')) {
          this.activeMenu = "user-manager";
        }else{
          this.activeMenu = "";
        }
      }
    });
  }

  logout(): void {
    sessionStorage.clear();
    this.calService.logout();
  }

  onRightClick(event: MouseEvent, url: string): void {
    // Prevent the browser's default right-click behavior
    event.preventDefault();

    // Open the URL in a new tab
    window.open(url, '_blank');
  }
  
  menuOpen = false;

  iconPacks = EMDMICONS;
  toggleMenu(event: Event) {
    this.menuOpen = !this.menuOpen;
  }

  @HostListener('window:resize', ['$event']) onResize(event: Event) {
    if (window.innerWidth > 768) {
      this.menuOpen = false;
    }

  }
}
